import { deferScript } from '@confluence/dom-helpers';
import { fg } from '@confluence/feature-gating';

import { ResourceRecorder } from './ResourceRecorder';

export class SuperbatchResourceRecorder extends ResourceRecorder {
	private includeConnect: boolean;
	private connectResource: string;
	private isJS: boolean;

	constructor(isJS: boolean) {
		super();
		this.includeConnect = false;
		this.connectResource = '';
		this.isJS = isJS;
	}

	reset() {
		super.reset();
		this.includeConnect = false;
		this.connectResource = '';
	}

	includeConnectWebResources() {
		this.includeConnect = true;
	}

	get() {
		if (!this.isJS) {
			return this.resource;
		}

		// Connect script needs superbatch so don't defer it
		return this.includeConnect && fg('content_early_connect_iframe_initialization')
			? this.resource
			: deferScript(this.resource);
	}

	addConnectResource(connectResource: string) {
		this.connectResource = connectResource;
	}

	getConnect() {
		return this.includeConnect && fg('content_early_connect_iframe_initialization')
			? this.connectResource
			: '';
	}
}
